import { authHttp } from '../http'
import * as routes from '../../routes/fiscal.routes'
import { errorHandler } from '../../../util/error.service'
import { parseToMysqlFormat } from '../../../util/date.service'

export async function getNfses(tpId, pInicial, pFinal) {
  try {
    const params = { pInicial: parseToMysqlFormat(pInicial), pFinal: parseToMysqlFormat(pFinal) }
    const { data } = await authHttp().get(routes.urlNfses(tpId), { params })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getNfse(tpId, id) {
  try {
    const { data } = await authHttp().get(routes.urlNfse(tpId, id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getEmissoresNfse(tpId) {
  try {
    const { data } = await authHttp().get(routes.urlEmissoresNfse(tpId))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getTomadorNfse(tpId, origem, id) {
  try {
    const { data } = await authHttp().get(routes.urlTomadorNfse(tpId), { params: { origem, id } })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getDadosEmissaoNfse(tpId, deliveriesIds) {
  try {
    const { data } = await authHttp().get(routes.urlDadosEmissaoNfse(tpId), {
      params: { deliveries_ids: deliveriesIds.join(',') },
    })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getNotasDisponiveisNfse(tpId, { pInicial, pFinal, companyId, cityId }) {
  try {
    const params = {
      pInicial: parseToMysqlFormat(pInicial),
      pFinal: parseToMysqlFormat(pFinal),
      company_id: companyId,
      city_id: cityId || undefined,
    }
    const { data } = await authHttp().get(routes.urlNotasDisponiveisNfse(tpId), { params })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postNfse(tpId, nfse) {
  try {
    const { data } = await authHttp().post(routes.urlNfses(tpId), nfse)
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postSincronizarNfse(tpId, id) {
  try {
    const { data } = await authHttp().post(routes.urlSincronizarNfse(tpId, id))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postCancelarNfse(tpId, id, justificativa) {
  try {
    const { data } = await authHttp().post(routes.urlCancelarNfse(tpId, id), { justificativa })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function postEmailNfse(tpId, id, emails) {
  try {
    const { data } = await authHttp().post(routes.urlEmailNfse(tpId, id), { emails })
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}
